import { Typography, Empty } from 'antd'
import { useRef } from 'react'
import styled from 'styled-components'
import { useVirtualList } from 'ahooks'
import emptyImg from '@/assets/imges/Empty/Empty.png'
import { t } from '@/i18n'

const ProgressContent = ({
  contentList = [],
  setLogInfo,
  wrapperHeight = 183,
  type,
}: {
  contentList: any[]
  setLogInfo: (logInfo: { visible: boolean; content: string; id?: string }) => void
  wrapperHeight?: number
  type?: number
}) => {
  const containerRef = useRef(null)
  const wrapperRef = useRef(null)
  const [list] = useVirtualList(contentList, {
    containerTarget: containerRef,
    wrapperTarget: wrapperRef,
    itemHeight: 36,
    overscan: 6,
  })
  return (
    <Wrapper wrapperHeight={wrapperHeight}>
      <div className="progress-content" id="scrollableDiv" ref={containerRef}>
        <div className="progress-list" ref={wrapperRef}>
          {list?.length > 0 &&
            list?.map((item, index) => (
              <div className="progress-item" key={index}>
                <div className="progress-item-name">
                  <Typography.Text className="payload-name" ellipsis={{ tooltip: true }}>
                    <span>
                      {item?.data?.caseName || item?.data?.pluginName || item?.data?.payloadName}
                    </span>
                  </Typography.Text>
                </div>
                <div className="progress-item-time">
                  {item?.data?.startTime ||
                    item?.data?.execStartTime ||
                    item?.data?.execTime ||
                    item?.data?.sendTime}
                </div>
                {type === 1 && (
                  <div
                    className="progress-item-log"
                    onClick={() => {
                      setLogInfo({
                        visible: true,
                        content:
                          item?.data?.failedReason ||
                          item?.data?.abnormalReason ||
                          item?.data?.execLog,
                        id: item?.data?.id,
                      })
                    }}
                  >
                    {t('执行日志')}
                  </div>
                )}
              </div>
            ))}
          {list?.length === 0 && (
            <div
              style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '100%' }}
            >
              <Empty image={emptyImg} />
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default ProgressContent

const Wrapper = styled.div`
  width: 100%;
  height: ${props => props.wrapperHeight}px;

  .progress-content {
    height: 100%;
    overflow: auto;
    background: #fff;
    padding: 0 12px;
  }

  .progress-list {
    position: relative;
    .progress-item {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 32px;
      background: #fafafa;
      border-radius: 6px;
      margin-bottom: 6px;
    }
  }

  .progress-item-name {
    display: flex;
    width: 50%;
    font-size: 14px;
    color: #666666;
  }
  .progress-item-time {
    flex: 1;
    text-align: right;
    color: #666666;
    font-size: 12px;
  }
  .progress-item-log {
    flex: 1;
    text-align: right;
    font-size: 12px;
    color: #4238c9;
    cursor: pointer;
    padding-right: 27px;
  }
`
